import { BookingProposalType } from '@navio/nsdk';

/**
 * True for every member of the recall family. Comparing against a single
 * recall type silently drops new ones from recall-only gating.
 */
export const isRecallProposalType = (
  type: BookingProposalType
): type is
  | typeof BookingProposalType.RECALL_PROPOSAL_WHEEL_CHANGE
  | typeof BookingProposalType.RECALL_PROPOSAL_TIRE_HOTEL =>
  type === BookingProposalType.RECALL_PROPOSAL_WHEEL_CHANGE || type === BookingProposalType.RECALL_PROPOSAL_TIRE_HOTEL;
